export default function DiningRDIcon() {
  return <svg
    xmlns="http://www.w3.org/2000/svg"
    width="46"
    height="62"
    fill="none"
    viewBox="0 0 46 62"
  >
    <g clipPath="url(#clip0_2211_8283)">
      <path
        fill="#FFBD0D"
        d="M31.999 27.83c7.732 0 14-6.23 14-13.915S39.732 0 32 0 17.996 6.23 17.996 13.915 24.266 27.83 32 27.83"
      ></path>
      <path
        fill="#fff"
        d="M31.999 26.087c-6.752 0-12.248-5.462-12.248-12.172S25.247 1.743 31.998 1.743c6.752 0 12.248 5.462 12.248 12.172S38.75 26.087 31.998 26.087m0-23.852c-6.482 0-11.753 5.239-11.753 11.68 0 6.442 5.271 11.68 11.753 11.68 6.481 0 11.753-5.238 11.753-11.68S38.48 2.235 31.998 2.235"
      ></path>
      <path
        fill="#EE3F34"
        d="M14.001 44.913c7.733 0 14.002-6.23 14.002-13.915S21.734 17.083 14 17.083C6.27 17.083 0 23.313 0 30.998s6.269 13.915 14.001 13.915"
      ></path>
      <path
        fill="#fff"
        d="M14.002 43.17c-6.752 0-12.248-5.462-12.248-12.172S7.25 18.826 14.002 18.826s12.247 5.462 12.247 12.172S20.753 43.17 14.002 43.17m0-23.852c-6.482 0-11.754 5.239-11.754 11.68 0 6.442 5.272 11.68 11.753 11.68 6.482 0 11.754-5.238 11.754-11.68s-5.272-11.68-11.753-11.68"
      ></path>
      <path
        fill="#54C1C3"
        d="M31.999 62c7.732 0 14-6.23 14-13.915S39.732 34.17 32 34.17 17.996 40.4 17.996 48.085 24.266 62 32 62"
      ></path>
      <path
        fill="#fff"
        d="M31.999 60.254c-6.752 0-12.248-5.462-12.248-12.172S25.243 35.91 31.998 35.91c6.756 0 12.248 5.462 12.248 12.172S38.75 60.254 31.998 60.254m0-23.85c-6.482 0-11.753 5.24-11.753 11.681 0 6.442 5.271 11.68 11.753 11.68 6.481 0 11.753-5.238 11.753-11.68s-5.272-11.68-11.754-11.68"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_2211_8283">
        <path fill="#fff" d="M0 0h46v62H0z"></path>
      </clipPath>
    </defs>
  </svg>;
}
